<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama atau kode voucher&hellip;"
                 aria-label="Cari voucher" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter tipe"
                  (change)="isType = $event.target.value; applyFilter()">
            <option value="">Semua tipe</option>
            <option value="0">Unik</option>
            <option value="1">Masal</option>
          </select>
          <select class="vl-select" aria-label="Filter status"
                  (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="1">Aktif</option>
            <option value="0">Nonaktif</option>
          </select>
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Buat Voucher</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Nama / Kode</th>
                  <th>Tipe</th>
                  <th>Background</th>
                  <th class="text-center">Jumlah</th>
                  <th class="text-center">Masa Aktif</th>
                  <th class="text-right">Harga</th>
                  <th>Status</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let g of isGrouped; let gi = index">
                  <!-- single row (MASAL or standalone UNIK) — expandable too -->
                  <tr *ngIf="!g.isGroup" class="vl-top" [class.vl-alt]="gi % 2 == 1" (click)="toggleSingle(g)">
                    <th class="vl-num">
                      {{rowNo(gi)}}
                      <span class="vl-chev" [class.open]="isExpanded['s' + g.v.id]"><i class="fa fa-chevron-right"></i></span>
                    </th>
                    <td><div class="vl-name-wrap"><span [innerHTML]="highlight(g.v.name)"></span></div></td>
                    <td>
                      <span *ngIf="g.v.type == 0" class="vl-tag unik">Unik</span>
                      <span *ngIf="g.v.type == 1" class="vl-tag masal">Masal</span>
                      <i class="fa fa-print vl-muted" *ngIf="g.v.is_printed" title="Cetak (fisik)"></i>
                    </td>
                    <td class="vl-muted">{{g.v.voucher_background.name}}</td>
                    <td class="text-center">
                      {{formatNumber(g.v.amount)}}
                      <div class="vl-muted vl-small">Sisa {{formatNumber(g.v.group_remaining)}}</div>
                    </td>
                    <td class="text-center">{{g.v.expired_day}} hari</td>
                    <td class="text-right">{{formatPrice(g.v.price)}}</td>
                    <td>
                      <span *ngIf="g.v.type == 1" class="vl-pill" [class.on]="g.v.status == 1" [class.off]="g.v.status == 0"><span class="vl-dot"></span>{{g.v.status == 1 ? 'Aktif' : 'Nonaktif'}}</span>
                      <span *ngIf="g.v.type == 0" class="vl-pill" [ngClass]="voucherStatusClass(g.v)"><span class="vl-dot"></span>{{voucherStatusLabel(g.v)}}</span>
                    </td>
                    <td>
                      <div class="vl-actions">
                        <button type="button" class="vl-icon" title="Edit" (click)="$event.stopPropagation(); onEdit(g.v)" data-bs-toggle="modal"
                                data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                        <button type="button" class="vl-icon print" title="Cetak" (click)="$event.stopPropagation(); viewVoucher(g.v)"><i class="fa fa-print"></i></button>
                        <button type="button" class="vl-icon danger" title="Hapus" (click)="$event.stopPropagation(); onDelete(g.v)"><i class="fa fa-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="!g.isGroup && isExpanded['s' + g.v.id]" class="vl-child">
                    <th class="vl-num">{{rowNo(gi)}}.1</th>
                    <td colspan="6">
                      <span class="vl-child-code">
                        <span class="vl-tree">&#9492;</span>
                        <code class="vl-code" [innerHTML]="highlight(g.v.code)"></code>
                        <button type="button" class="vl-copy" title="Salin kode" (click)="copyCode(g.v.code)">
                          <i class="fa fa-copy"></i></button>
                      </span>
                    </td>
                    <td>
                      <span *ngIf="g.v.type == 1" class="vl-pill" [class.on]="g.v.status == 1" [class.off]="g.v.status == 0"><span class="vl-dot"></span>{{g.v.status == 1 ? 'Aktif' : 'Nonaktif'}}</span>
                      <span *ngIf="g.v.type == 0" class="vl-pill" [ngClass]="voucherStatusClass(g.v)"><span class="vl-dot"></span>{{voucherStatusLabel(g.v)}}</span>
                    </td>
                    <td></td>
                  </tr>

                  <!-- UNIK voucher group row -->
                  <tr *ngIf="g.isGroup" class="vl-top" [class.vl-alt]="gi % 2 == 1" (click)="toggleGroup(g)">
                    <th class="vl-num">
                      {{rowNo(gi)}}
                      <span class="vl-chev" [class.open]="isExpanded[g.key] && !g.loading">
                        <i class="fa" [ngClass]="g.loading ? 'fa-spinner fa-spin' : 'fa-chevron-right'"></i></span>
                    </th>
                    <td>
                      <div class="vl-name-wrap">
                        <span [innerHTML]="highlight(g.name)"></span>
                        <span class="vl-chip">{{formatNumber(g.count)}} kode</span>
                      </div>
                    </td>
                    <td><span class="vl-tag unik">Unik</span> <i class="fa fa-print vl-muted" *ngIf="g.header.is_printed" title="Cetak (fisik)"></i></td>
                    <td class="vl-muted">{{g.header.voucher_background.name}}</td>
                    <td class="text-center">
                      {{formatNumber(g.count)}}
                      <div class="vl-muted vl-small">Sisa {{formatNumber(g.header.group_remaining)}}</div>
                    </td>
                    <td class="text-center">{{g.header.expired_day}} hari</td>
                    <td class="text-right">{{formatPrice(g.header.price)}}</td>
                    <td class="vl-muted vl-small">{{formatNumber(g.header.active_count)}} aktif</td>
                    <td>
                      <div class="vl-actions">
                        <button type="button" class="vl-icon print" title="Cetak semua"
                                (click)="$event.stopPropagation(); viewVoucherGroup(g)"><i class="fa fa-print"></i></button>
                        <button type="button" class="vl-icon danger" title="Hapus semua"
                                (click)="$event.stopPropagation(); onDeleteGroup(g)"><i class="fa fa-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                  <ng-container *ngIf="g.isGroup && isExpanded[g.key]">
                    <tr *ngFor="let it of g.visible; let j = index" class="vl-child">
                      <th class="vl-num">{{rowNo(gi)}}.{{j + 1}}</th>
                      <td colspan="6">
                        <span class="vl-child-code">
                          <span class="vl-tree">&#9492;</span>
                          <code class="vl-code" [innerHTML]="highlight(it.code)"></code>
                          <button type="button" class="vl-copy" title="Salin kode" (click)="copyCode(it.code)">
                            <i class="fa fa-copy"></i></button>
                        </span>
                      </td>
                      <td>
                        <span class="vl-pill" [ngClass]="voucherStatusClass(it)"><span class="vl-dot"></span>{{voucherStatusLabel(it)}}</span>
                      </td>
                      <td>
                        <div class="vl-actions">
                          <button type="button" class="vl-icon" title="Edit" (click)="onEdit(it)" data-bs-toggle="modal"
                                  data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                          <button type="button" class="vl-icon print" title="Cetak" (click)="viewVoucher(it)"><i class="fa fa-print"></i></button>
                          <button type="button" class="vl-icon danger" title="Hapus" (click)="onDelete(it)"><i class="fa fa-trash"></i></button>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="g.items.length && g.visible.length < g.items.length" class="vl-child">
                      <th class="vl-num"></th>
                      <td colspan="8" class="vl-muted vl-small">
                        {{formatNumber(g.items.length - g.visible.length)}} kode lain di grup ini tidak cocok dengan pencarian.</td>
                    </tr>
                  </ng-container>
                </ng-container>
                <tr *ngIf="!isGrouped.length">
                  <td colspan="9" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> voucher</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit voucher' : 'Buat voucher'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui detail voucher ini.' : 'Isi detail voucher yang akan diterbitkan.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full">
              <label class="vf-label">Nama <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('name')"
                     placeholder="Nama voucher, misal: Promo Ramadhan" formControlName="name">
              <div class="vf-error" *ngIf="isInvalid('name')">Nama wajib diisi.</div>
            </div>
            <div class="vf-field full" [class.vf-invalid]="isInvalid('voucher_background_id')">
              <label class="vf-label">Background <span class="req">*</span></label>
              <ng-select2 formControlName="voucher_background_id" [data]="dataBackground"
                          [placeholder]="'Pilih background desain'"></ng-select2>
              <div class="vf-error" *ngIf="isInvalid('voucher_background_id')">Background wajib dipilih.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">{{isForm.value.id ? 'Kode' : 'Kode Awal'}} <span class="req">*</span></label>
              <input type="text" (keyup)="validationCode($event)" (input)="onCodeInput($event)"
                     [maxlength]="isForm.value.id?15:10" class="vf-input vf-mono" [class.invalid]="isInvalid('code')"
                     placeholder="Misal: HATAM" formControlName="code">
              <div class="vf-error" *ngIf="isInvalid('code')">Kode awal wajib diisi.</div>
              <div class="vf-hint" *ngIf="!isForm.value.id">Maksimal 10 karakter. Sistem menambahkan kode unik otomatis di belakangnya —
                <code class="vf-hint-code">HATAM</code> menjadi <code class="vf-hint-code">HATAM<b>KODEUNIK</b></code>.</div>
              <div class="vf-hint" *ngIf="isForm.get('code').disabled">Kode tidak bisa diubah karena voucher ini sudah pernah dipakai pengguna.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Tipe <span class="req">*</span></label>
              <select class="vf-input vf-select" [class.invalid]="isInvalid('type')" formControlName="type">
                <option [ngValue]="''" disabled hidden>Pilih tipe</option>
                <option *ngFor="let d of dataType" [ngValue]="d.id">{{d.text}}</option>
              </select>
              <div class="vf-error" *ngIf="isInvalid('type')">Tipe wajib dipilih.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Jenis <span class="req">*</span></label>
              <select class="vf-input vf-select" [class.invalid]="isInvalid('is_printed')" formControlName="is_printed">
                <option *ngFor="let d of dataJenis" [ngValue]="d.id">{{d.text}}</option>
              </select>
              <div class="vf-error" *ngIf="isInvalid('is_printed')">Jenis wajib dipilih.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Status <span class="req">*</span></label>
              <select class="vf-input vf-select" [class.invalid]="isInvalid('status')" formControlName="status">
                <option [ngValue]="''" disabled hidden>Pilih status</option>
                <option *ngFor="let d of dataStatus" [ngValue]="d.id">{{d.text}}</option>
              </select>
              <div class="vf-error" *ngIf="isInvalid('status')">Status wajib dipilih.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Jumlah <span class="req">*</span></label>
              <input type="text" inputmode="numeric" class="vf-input" [class.invalid]="isInvalid('amount')" placeholder="0"
                     (input)="onNumberInput($event, 'amount')" formControlName="amount">
              <div class="vf-hint" *ngIf="isForm.get('amount').disabled">
                Voucher unik selalu 1 per kode — tambah kode lewat Buat Voucher baru.</div>
              <div class="vf-error" *ngIf="isInvalid('amount')">Jumlah wajib diisi.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Masa aktif <span class="req">*</span></label>
              <div class="vf-affix">
                <input type="text" inputmode="numeric" class="vf-input vf-has-suffix" [class.invalid]="isInvalid('expired_day')"
                       placeholder="60" (input)="onNumberInput($event, 'expired_day')" formControlName="expired_day">
                <span class="suffix">hari</span>
              </div>
              <div class="vf-error" *ngIf="isInvalid('expired_day')">Masa aktif wajib diisi.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Harga <span class="req">*</span></label>
              <div class="vf-affix">
                <span class="prefix">Rp</span>
                <input type="text" inputmode="numeric" class="vf-input vf-has-prefix" [class.invalid]="isInvalid('price')"
                       placeholder="0" (input)="onNumberInput($event, 'price')" formControlName="price">
              </div>
              <div class="vf-hint">Isi 0 untuk voucher gratis.</div>
              <div class="vf-error" *ngIf="isInvalid('price')">Harga wajib diisi (0 untuk gratis).</div>
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- delete confirmation dialog (custom, per mockup) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">

    <!-- single: minimal, centered -->
    <ng-container *ngIf="isConfirm.mode === 'single'">
      <div class="hds-a">
        <span class="hds-ico">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
        </span>
        <h3>Hapus voucher ini?</h3>
        <p>Tindakan ini tidak bisa dibatalkan.</p>
        <div class="hds-item"><code>{{isConfirm.v.code}}</code> {{isConfirm.v.name}}</div>
      </div>
      <div class="hds-foot hds-foot-full">
        <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
        <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
          <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
      </div>
    </ng-container>

    <!-- group: detail panel + warning -->
    <ng-container *ngIf="isConfirm.mode === 'group'">
      <div class="hds-b">
        <h3>Hapus grup voucher?</h3>
        <p class="hds-sub">Periksa kembali sebelum menghapus.</p>
        <div class="hds-panel">
          <div class="hds-row"><span>Nama</span><b>{{isConfirm.g.name}}</b></div>
          <div class="hds-row"><span>Jumlah kode</span><b><span class="hds-chip">{{formatNumber(isConfirm.g.count)}} kode</span></b></div>
          <div class="hds-row"><span>Status</span>
            <b>{{formatNumber(isConfirm.g.header.active_count)}} aktif &middot;
              {{formatNumber(isConfirm.g.count - (isConfirm.g.header.active_count || 0))}} nonaktif</b></div>
        </div>
        <div class="hds-warn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0zM12 9v4M12 17h.01"/></svg>
          <span>Seluruh {{formatNumber(isConfirm.g.count)}} kode dihapus permanen &mdash;
            kode yang sudah dibagikan ke pengguna tidak akan bisa dipakai lagi.</span>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
        <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
          <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus {{formatNumber(isConfirm.g.count)}} Voucher</button>
      </div>
    </ng-container>

  </div>
</div>

<div class="modal fade" id="modalVoucher" aria-labelledby="modalVoucherLabel" aria-hidden="true" data-keyboard="false"
     data-backdrop="static">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header vf-header">
        <div>
          <h6 class="modal-title vf-title" id="modalVoucherLabel">Cetak voucher</h6>
          <div class="vf-subtitle">{{isPrintName}}</div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isExporting"></button>
      </div>
      <div class="modal-body">
        <div class="vp-seg-row">
          <span class="vp-seg-lbl">Format</span>
          <div class="vp-seg">
            <button type="button" [class.on]="isPrintFormat == 'pdf'" (click)="setPrintFormat('pdf')">PDF</button>
            <button type="button" [class.on]="isPrintFormat == 'png'" (click)="setPrintFormat('png')">PNG</button>
            <button type="button" [class.on]="isPrintFormat == 'jpg'" (click)="setPrintFormat('jpg')">JPG</button>
          </div>
        </div>
        <div class="vp-preview">
          <div class="vp-grid" [class.single]="isPrintList.length == 1">
            <div class="vp-cell" *ngFor="let p of isPreviewList">
              <div class="card-voucher" style="background-image: url('{{p.voucher_background.image}}');">
                <p style="margin-top: 9.5rem !important; text-align: center;" class="text-dark">
                  <b>{{p.code}} - Aktif: {{p.expired_day}} Hari</b>
                </p>
              </div>
            </div>
            <div class="vp-cell vp-more" *ngIf="isPrintList.length > isPreviewList.length">
              + {{formatNumber(isPrintList.length - isPreviewList.length)}} kode lainnya ikut diekspor
            </div>
          </div>
        </div>

        <div class="vp-out">
          <span class="vp-oico">{{printBadge()}}</span>
          <div class="vp-otext">
            <div class="vp-oname">{{printDesc()}} &mdash; <code class="vp-fname">{{printFileName()}}</code></div>
            <div class="vp-osub">{{printSub()}}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer vf-footer">
        <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isExporting">Batal</button>
        <button type="button" class="vl-btn-primary" (click)="onExport()" [disabled]="isExporting">
          <i class="fa fa-spinner fa-spin" *ngIf="isExporting"></i>
          <i class="fa fa-download" *ngIf="!isExporting"></i> {{exportButtonLabel()}}</button>
      </div>
    </div>
  </div>
</div>
